import { useIntl } from "react-intl";
import styles from "./AssetDetails.module.scss";
import { UnsafeHtml } from "../../../../common/core-ui/UnsafeHtml.tsx";
import BasicAssetFields from "./BasicAssetFields.tsx";
import ExploreBorrowingFields from "./ExploreBorrowingFields.tsx";
import {
  License,
  ManageAsset,
} from "../../../../common/api/decimal/common-types/manageAssets.ts";

export default function AssetDetails({
  asset,
  license,
  explore,
}: {
  asset?: ManageAsset;
  license?: License;
  explore?: VST.Bridge.Asset;
}) {
  const intl = useIntl();
  // Fall back to explore-only data if we don't have manage data, such as in explore search
  const commonAsset = asset ?? explore!;

  return (
    <div className={styles.outerContainer}>
      {explore && <ExploreBorrowingFields explore={explore} />}
      {commonAsset && (
        <BasicAssetFields asset={commonAsset} license={license} />
      )}
      {commonAsset.description && (
        <div className={styles.descriptionContainer}>
          <h3>{intl.formatMessage({ defaultMessage: "Description" })}</h3>
          <UnsafeHtml>{commonAsset.description}</UnsafeHtml>
        </div>
      )}
    </div>
  );
}
